import React from 'react';
import { auth } from '../../firebaseConfig';
import { useAuthState } from "react-firebase-hooks/auth";
import { useUserData } from '../../hooks/useUsers';
import { onAcceptFriend } from "../../hooks/onAcceptFriend";
import { onDeclineFriendRequest } from "../../hooks/onDeclineFriendRequest";
import { Button, Typography } from 'antd';
import { CheckOutlined, CloseCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

function Request({ id }) {
    const [user] = useAuthState(auth);
    const { userData } = useUserData(id);

  async function handleAccept() {
    await onAcceptFriend(user.uid, id);
  }

  function handleDecline() {
    onDeclineFriendRequest(id, user.uid);
  }

  return (
    <div style={{
      background: 'rgba(255, 255, 255, 0.95)',
      borderRadius: '12px',
      padding: '16px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.3)'
    }}>
      <div style={{ marginBottom: '12px' }}>
        <Text style={{ 
          fontSize: '14px',
          color: '#2c3e50',
          fontWeight: '500',
          lineHeight: '1.4'
        }}>
          <Text strong style={{ color: '#667eea' }}>
            {userData?.firstName + ' ' + userData?.lastName}
          </Text>
          {' '}is interested in your profile
        </Text>
      </div>
      
      <div style={{ 
        display: 'flex', 
        gap: '8px',
        justifyContent: 'center'
      }}>
        <Button 
          type="primary"
          onClick={handleAccept}
          style={{
            background: 'linear-gradient(135deg, #52c41a 0%, #73d13d 100%)',
            borderColor: '#52c41a',
            borderRadius: '8px',
            fontWeight: '600',
            boxShadow: '0 4px 12px rgba(82, 196, 26, 0.3)',
            transition: 'all 0.3s ease',
            flex: 1
          }}
          icon={<CheckOutlined />}
        >
          Accept
        </Button>
        
        <Button 
          danger 
          onClick={handleDecline}
          style={{
            borderRadius: '8px',
            fontWeight: '600',
            boxShadow: '0 4px 12px rgba(255, 77, 79, 0.3)',
            transition: 'all 0.3s ease',
            flex: 1
          }}
          icon={<CloseCircleOutlined />}
        >
          Decline
        </Button>
      </div>
    </div>
  );
};

export default Request;